export const translations = {
  en: {
    welcomeMessage: "Hello! I am LAFly, your virtual assistant from Latte Art Factory. I am here to help you out with your Latte Art Factory machine. I can only help you if you already own one.",
    privacyMessage: "Make sure you activate user cookies to get the best user experience! Before we move on, please make sure to read and accept the",
    privacyPolicy: "Privacy Policy",
    accept: "Accept",
    sessionExpired: "Chat session has expired after 30 minutes. Please refresh the page to start a new chat.",
    refreshPage: "Refresh Page",
    wasHelpful: "Did this resolve your issue?",
    yes: "Yes",
    no: "No",
    notHelpfulMessage: "Sorry I couldn't help with this issue. Please provide more details and try again. If you still need assistance, then please contact your reseller for further assistance. This link can be helpful: https://latteartfactory.com/latte-art-factory-approved-distributors.",
    thankYouMessage: "That's great! If you have any more questions or need further assistance, feel free to reach out. Have a great day!",
    typingIndicator: "LAFly is typing...",
    feedbackMessage: "Please provide feedback before continuing",
    inputPlaceholder: "Type your message here",
    partnerWelcomeMessage: "Hello! I'm your virtual assistant from Latte Art Factory. I'm here to assist partners with any inquiries regarding the machine",
    partnerHeader: "Partner Chatbot"
  },
  fr: {
    welcomeMessage: "Bonjour! Je suis LAFly, votre assistant virtuel de Latte Art Factory. Je suis là pour vous aider avec votre machine Latte Art Factory. Je ne peux vous aider que si vous en possédez déjà une.",
    privacyMessage: "Assurez-vous d'activer les cookies utilisateur pour obtenir la meilleure expérience! Avant de continuer, veuillez lire et accepter la",
    privacyPolicy: "Politique de Confidentialité",
    accept: "Accepter",
    sessionExpired: "La session de chat a expiré après 30 minutes. Veuillez rafraîchir la page pour démarrer un nouveau chat.",
    refreshPage: "Rafraîchir la Page",
    wasHelpful: "Cela a-t-il résolu votre problème?",
    yes: "Oui",
    no: "Non",
    notHelpfulMessage: "Désolé, je n'ai pas pu vous aider avec ce problème. Veuillez fournir plus de détails et réessayer. Si vous avez encore besoin d'aide, veuillez contacter votre revendeur pour plus d'assistance. Ce lien peut être utile : https://latteartfactory.com/latte-art-factory-approved-distributors.",
    thankYouMessage: "C'est génial! Si vous avez d'autres questions ou besoin d'aide supplémentaire, n'hésitez pas à me contacter. Bonne journée!",
    typingIndicator: "LAFly est en train d'écrire...",
    feedbackMessage: "Veuillez fournir votre avis avant de continuer",
    inputPlaceholder: "Tapez votre message ici",
    partnerWelcomeMessage: "Bonjour! Je suis votre assistant virtuel de Latte Art Factory. Je suis là pour aider les partenaires avec toute question concernant la machine",
    partnerHeader: "Chatbot Partenaire"
  },
  pr: {
    welcomeMessage: "Olá! Eu sou LAFly, seu assistente virtual da Latte Art Factory. Estou aqui para ajudá-lo com sua máquina Latte Art Factory. Só posso ajudar se você já possui uma.",
    privacyMessage: "Certifique-se de ativar os cookies do usuário para obter a melhor experiência! Antes de continuar, leia e aceite a",
    privacyPolicy: "Política de Privacidade",
    accept: "Aceitar",
    sessionExpired: "A sessão de chat expirou após 30 minutos. Atualize a página para iniciar um novo chat.",
    refreshPage: "Atualizar Página",
    wasHelpful: "Isso resolveu seu problema?",
    yes: "Sim",
    no: "Não",
    notHelpfulMessage: "Desculpe, não consegui ajudar com este problema. Por favor, forneça mais detalhes e tente novamente. Se ainda precisar de assistência, entre em contato com seu revendedor para mais ajuda. Este link pode ser útil: https://latteartfactory.com/latte-art-factory-approved-distributors.",
    thankYouMessage: "Isso é ótimo! Se você tiver mais perguntas ou precisar de ajuda adicional, não hesite em entrar em contato. Tenha um ótimo dia!",
    typingIndicator: "LAFly está digitando...",
    feedbackMessage: "Por favor, forneça feedback antes de continuar",
    inputPlaceholder: "Digite sua mensagem aqui",
    partnerWelcomeMessage: "Olá! Sou seu assistente virtual da Latte Art Factory. Estou aqui para ajudar parceiros com qualquer consulta sobre a máquina",
    partnerHeader: "Chatbot Parceiro"
  },
  sp: {
    welcomeMessage: "¡Hola! Soy LAFly, tu asistente virtual de Latte Art Factory. Estoy aquí para ayudarte con tu máquina Latte Art Factory. Solo puedo ayudar si ya posees una.",
    privacyMessage: "¡Asegúrate de activar las cookies de usuario para obtener la mejor experiencia! Antes de continuar, por favor lee y acepta la",
    privacyPolicy: "Política de Privacidad",
    accept: "Aceptar",
    sessionExpired: "La sesión de chat ha expirado después de 30 minutos. Por favor, actualiza la página para iniciar un nuevo chat.",
    refreshPage: "Actualizar Página",
    wasHelpful: "¿Esto resolvió tu problema?",
    yes: "Sí",
    no: "No",
    notHelpfulMessage: "Lo siento, no pude ayudar con este problema. Por favor, proporciona más detalles e inténtalo de nuevo. Si aún necesitas ayuda, contacta con tu distribuidor para obtener más asistencia. Este enlace puede ser útil: https://latteartfactory.com/latte-art-factory-approved-distributors.",
    thankYouMessage: "¡Eso es genial! Si tienes más preguntas o necesitas ayuda adicional, no dudes en contactarnos. ¡Que tengas un excelente día!",
    typingIndicator: "LAFly está escribiendo...",
    feedbackMessage: "Por favor, proporciona tu opinión antes de continuar",
    inputPlaceholder: "Escribe tu mensaje aquí",
    partnerWelcomeMessage: "¡Hola! Soy tu asistente virtual de Latte Art Factory. Estoy aquí para ayudar a los socios con cualquier consulta sobre la máquina",
    partnerHeader: "Chatbot Socio"
  },
  ar: {
    welcomeMessage: "مرحباً! أنا LAFly، مساعدك الافتراضي من Latte Art Factory. أنا هنا لمساعدتك في استخدام جهاز Latte Art Factory الخاص بك. يمكنني المساعدة فقط إذا كنت تمتلك واحداً بالفعل.",
    privacyMessage: "تأكد من تفعيل ملفات تعريف الارتباط للحصول على أفضل تجربة! قبل المتابعة، يرجى قراءة وقبول",
    privacyPolicy: "سياسة الخصوصية",
    accept: "قبول",
    sessionExpired: "انتهت جلسة المحادثة بعد 30 دقيقة. يرجى تحديث الصفحة لبدء محادثة جديدة.",
    refreshPage: "تحديث الصفحة",
    wasHelpful: "هل تم حل مشكلتك؟",
    yes: "نعم",
    no: "لا",
    notHelpfulMessage: "عذراً، لم أتمكن من المساعدة في هذه المشكلة. يرجى تقديم مزيد من التفاصيل والمحاولة مرة أخرى. إذا كنت لا تزال بحاجة إلى مساعدة، يرجى الاتصال بالموزع الخاص بك للحصول على مزيد من المساعدة. يمكن أن يكون هذا الرابط مفيدًا: https://latteartfactory.com/latte-art-factory-approved-distributors.",
    thankYouMessage: "هذا رائع! إذا كان لديك المزيد من الأسئلة أو تحتاج إلى مساعدة إضافية، لا تتردد في التواصل معنا. أتمنى لك يوماً سعيداً!",
    typingIndicator: "...LAFly يكتب",
    feedbackMessage: "يرجى تقديم ملاحظاتك قبل المتابعة",
    inputPlaceholder: "اكتب رسالتك هنا",
    partnerWelcomeMessage: "مرحباً! أنا مساعدك الافتراضي من Latte Art Factory. أنا هنا لمساعدة الشركاء في أي استفسارات حول الآلة",
    partnerHeader: "شات بوت الشريك"
  },
  ch: {
    welcomeMessage: "你好！我是 LAFly，来自 Latte Art Factory 的虚拟助手。我在这里帮助您使用 Latte Art Factory 咖啡机。我只能在您已经拥有咖啡机的情况下提供帮助。",
    privacyMessage: "请确保启用用户 cookie 以获得最佳体验！在继续之前，请务必阅读并接受",
    privacyPolicy: "隐私政策",
    accept: "接受",
    sessionExpired: "聊天会话已在 30 分钟后过期。请刷新页面以开始新的聊天。",
    refreshPage: "刷新页面",
    wasHelpful: "这是否解决了您的问题？",
    yes: "是",
    no: "否",
    notHelpfulMessage: "抱歉，我找不到关于这个具体问题的信息。请通过以下链接联系服务提供商以获取更多帮助：[https://latteartfactory.com/latte-art-factory-approved-distributors](https://latteartfactory.com/latte-art-factory-approved-distributors/)",
    thankYouMessage: "太好了！如果您还有任何问题或需要进一步帮助，请随时联系我们。祝您有愉快的一天！",
    typingIndicator: "LAFly 正在输入...",
    feedbackMessage: "请在继续之前提供反馈",
    inputPlaceholder: "在此输入您的消息",
    partnerWelcomeMessage: "你好！我是 Latte Art Factory 的虚拟助手。我在这里帮助合作伙伴解决任何关于机器的询问",
    partnerHeader: "合作伙伴聊天机器人"
  },
  dh: {
    welcomeMessage: "Hallo! Ik ben LAFly, je virtuele assistent van Latte Art Factory. Ik ben hier om je te helpen met je Latte Art Factory machine. Ik kan alleen helpen als je er al een bezit.",
    privacyMessage: "Zorg ervoor dat je gebruikerscookies activeert voor de beste gebruikerservaring! Voordat we verdergaan, lees en accepteer eerst de",
    privacyPolicy: "Privacybeleid",
    accept: "Accepteren",
    sessionExpired: "Chatsessie is verlopen na 30 minuten. Vernieuw de pagina om een nieuwe chat te starten.",
    refreshPage: "Pagina Vernieuwen",
    wasHelpful: "Heeft dit je probleem opgelost?",
    yes: "Ja",
    no: "Nee",
    notHelpfulMessage: "Sorry I couldn't help with this issue. Please provide more details and try again. If you still need assistance, then please contact your reseller for further assistance. This link can be helpful: https://latteartfactory.com/latte-art-factory-approved-distributors.",
    thankYouMessage: "Dat is geweldig! Als je nog vragen hebt of verdere hulp nodig hebt, neem dan gerust contact op. Fijne dag!",
    typingIndicator: "LAFly is aan het typen...",
    feedbackMessage: "Geef alstublieft feedback voordat u verdergaat",
    inputPlaceholder: "Typ uw bericht hier",
    partnerWelcomeMessage: "Hallo! Ik ben uw virtuele assistent van Latte Art Factory. Ik ben hier om partners te helpen met vragen over de machine",
    partnerHeader: "Partner Chatbot"
  },
  gr: {
    welcomeMessage: "Hallo! Ich bin LAFly, Ihr virtueller Assistent von Latte Art Factory. Ich bin hier, um Ihnen mit Ihrer Latte Art Factory Maschine zu helfen. Ich kann nur helfen, wenn Sie bereits eine besitzen.",
    privacyMessage: "Aktivieren Sie Benutzer-Cookies für die beste Nutzererfahrung! Bevor wir fortfahren, lesen und akzeptieren Sie bitte die",
    privacyPolicy: "Datenschutzerklärung",
    accept: "Akzeptieren",
    sessionExpired: "Chat-Sitzung ist nach 30 Minuten abgelaufen. Bitte aktualisieren Sie die Seite, um einen neuen Chat zu starten.",
    refreshPage: "Seite Aktualisieren",
    wasHelpful: "Hat dies Ihr Problem gelöst?",
    yes: "Ja",
    no: "Nein",
    notHelpfulMessage: "Entschuldigung, ich konnte bei diesem Problem nicht helfen. Bitte geben Sie mehr Details an und versuchen Sie es erneut. Wenn Sie weiterhin Hilfe benötigen, wenden Sie sich bitte an Ihren Händler für weitere Unterstützung. Dieser Link kann hilfreich sein: https://latteartfactory.com/latte-art-factory-approved-distributors.",
    thankYouMessage: "Das ist großartig! Wenn Sie weitere Fragen haben oder zusätzliche Hilfe benötigen, können Sie sich jederzeit an uns wenden. Einen schönen Tag noch!",
    typingIndicator: "LAFly schreibt...",
    feedbackMessage: "Bitte geben Sie Feedback, bevor Sie fortfahren",
    inputPlaceholder: "Geben Sie Ihre Nachricht hier ein",
    partnerWelcomeMessage: "Hallo! Ich bin Ihr virtueller Assistent von Latte Art Factory. Ich bin hier, um Partnern bei Fragen zur Maschine zu helfen",
    partnerHeader: "Partner Chatbot"
  },
  it: {
    welcomeMessage: "Ciao! Sono LAFly, il tuo assistente virtuale di Latte Art Factory. Sono qui per aiutarti con la tua macchina Latte Art Factory. Posso aiutarti solo se ne possiedi già una.",
    privacyMessage: "Assicurati di attivare i cookie utente per la migliore esperienza! Prima di continuare, leggi e accetta la",
    privacyPolicy: "Informativa sulla Privacy",
    accept: "Accetta",
    sessionExpired: "La sessione di chat è scaduta dopo 30 minuti. Aggiorna la pagina per iniziare una nuova chat.",
    refreshPage: "Aggiorna Pagina",
    wasHelpful: "Questo ha risolto il tuo problema?",
    yes: "Sì",
    no: "No",
    notHelpfulMessage: "Mi dispiace, ma non ho trovato informazioni su questo problema specifico. Contatta un fornitore di servizi per ulteriore assistenza utilizzando [https://latteartfactory.com/latte-art-factory-approved-distributors](https://latteartfactory.com/latte-art-factory-approved-distributors/)",
    thankYouMessage: "Fantastico! Se hai altre domande o hai bisogno di ulteriore assistenza, non esitare a contattarci. Buona giornata!",
    typingIndicator: "LAFly sta scrivendo...",
    feedbackMessage: "Per favore, fornisci un feedback prima di continuare",
    inputPlaceholder: "Scrivi il tuo messaggio qui",
    partnerWelcomeMessage: "Ciao! Sono il tuo assistente virtuale di Latte Art Factory. Sono qui per aiutare i partner con qualsiasi domanda riguardo alla macchina",
    partnerHeader: "Chatbot Partner"
  },
  jp: {
    welcomeMessage: "こんにちは！私はLAFlyです。Latte Art Factoryの仮想アシスタントとして、お客様のLatte Art Factory マシンのサポートをさせていただきます。すでにマシンをお持ちの方のみサポート可能です。",
    privacyMessage: "最高のユーザー体験を得るために、ユーザークッキーを有効にしてください！続行する前に、以下のプライバシーポリシーをお読みいただき、同意をお願いします。",
    privacyPolicy: "プライバシーポリシー",
    accept: "同意する",
    sessionExpired: "チャットセッションが30分後に終了しました。新しいチャットを開始するには、ページを更新してください。",
    refreshPage: "ページを更新",
    wasHelpful: "問題は解決しましたか？",
    yes: "はい",
    no: "いいえ",
    notHelpfulMessage: "申し訳ありませんが、この問題を解決できませんでした。詳細を提供して再試行してください。まだサポートが必要な場合は、リセラーにお問い合わせください。このリンクが役立つかもしれません：https://latteartfactory.com/latte-art-factory-approved-distributors.",
    thankYouMessage: "それは素晴らしいです！他にご質問やサポートが必要な場合は、お気軽にお申し付けください。良い一日をお過ごしください！",
    typingIndicator: "LAFly が入力中...",
    feedbackMessage: "続行する前にフィードバックをお願いします",
    inputPlaceholder: "メッセージを入力してください",
    partnerWelcomeMessage: "こんにちは！私はLatte Art Factoryの仮想アシスタントです。パートナーの方々のマシンに関するお問い合わせをお手伝いいたします",
    partnerHeader: "パートナーチャットボット"
  },
  ko: {
    welcomeMessage: "안녕하세요! 저는 Latte Art Factory의 가상 어시스턴트 LAFly입니다. Latte Art Factory 머신 사용을 도와드리겠습니다. 이미 제품을 소유하고 계신 분들만 도와드릴 수 있습니다.",
    privacyMessage: "최상의 사용자 경험을 위해 사용자 쿠키를 활성화해 주세요! 계속하기 전에 다음의 개인정보 처리방침을 읽고 동의해 주세요.",
    privacyPolicy: "개인정보 처리방침",
    accept: "동의",
    sessionExpired: "채팅 세션이 30분 후 만료되었습니다. 새로운 채팅을 시작하려면 페이지를 새로고침하세요.",
    refreshPage: "페이지 새로고침",
    wasHelpful: "문제가 해결되었나요?",
    yes: "예",
    no: "아니오",
    notHelpfulMessage: "죄송합니다. 이 문제를 해결할 수 없습니다. 더 많은 세부 정보를 제공하고 다시 시도하십시오. 여전히 도움이 필요하면 리셀러에게 문의하십시오. 이 링크가 도움이 될 수 있습니다: https://latteartfactory.com/latte-art-factory-approved-distributors.",
    thankYouMessage: "그것은 훌륭합니다! 추가 질문이나 도움이 필요하시면 언제든 문의해 주세요. 좋은 하루 보내세요!",
    typingIndicator: "LAFly 입력 중...",
    feedbackMessage: "계속하기 전에 피드백을 제공해 주세요",
    inputPlaceholder: "메시지를 입력하세요",
    partnerWelcomeMessage: "안녕하세요! 저는 Latte Art Factory의 가상 어시스턴트입니다. 파트너들의 기계 관련 문의를 도와드리겠습니다",
    partnerHeader: "파트너 챗봇"
  }
};

export type Language = keyof typeof translations;
export type TranslationKey = keyof typeof translations['en']; 